import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader
} from "reactstrap";
import { withRouter } from "react-router-dom";

import { connect } from 'react-redux';

import { withNamespaces } from 'react-i18next';
import {AvField, AvForm} from "availity-reactstrap-validation";
import { Tabs } from 'antd';
import toastr from "toastr";
import { paramPut, paramPost } from "../../apiHelpers/commonApiHelper";
import {call} from "redux-saga/effects";
import {deviseLogout} from "../../apiHelpers/authHelper";

const { TabPane } = Tabs;





const Dashboard = (props) => {


    useEffect(() => {
        const header = JSON.parse(localStorage.getItem("authUser"));
        setName(header.data.name);
        setEmail(header.data.email);
    }, [])

    const [name, setName] = useState(undefined)
    const [email, setEmail] = useState(undefined)
    const [nameUpdating, setNameUpdating] = useState(false);
    const [pwUpdating, setPwUpdating] = useState(false)

    const  handleUserName = (e, values) => {
        setNameUpdating(true);
        paramPost('api/v1/update_uesr', values)
            .then((result) => {
                setNameUpdating(false);
                if(result.data.success) {
                    let header = JSON.parse(localStorage.getItem("authUser"));
                    header.data.name = JSON.parse(result.data.user)[0].name;
                    localStorage.setItem("authUser", JSON.stringify(header));
                    toastr.success("Updated successfully", "Success");
                } else {
                    toastr.error("Something went wrong. Please try again", "Error");
                }
            })
            .catch((err) => {
                setNameUpdating(false);
            })
    }

    const handlePassword = (e, values) => {
        setPwUpdating(true);
        paramPut('/api/v1/auth/password', values)
            .then(result => {
                setPwUpdating(false);
                if(result.status === 200) {
                    toastr.success("Password updated successfully", "Success");
                    setTimeout(() => logout(), 1000);
                } else {
                    toastr.error(result.data.errors.full_messages[0], "Error");
                }
            })
            .catch(err => {
                setPwUpdating(false);
            })
    }

    function logout() {
        const localHeaders = JSON.parse(localStorage.getItem("authHeaders"))
        const headers = {
            accesstoken: localHeaders.accesstoken,
            client: localHeaders.client,
            uid: localHeaders.uid
        }
        deviseLogout('/api/v1/auth/sign_out', { ...headers })
            .then(response => {
                if (response.success) {
                    localStorage.removeItem("authUser");
                    localStorage.removeItem("authHeaders");
                    localStorage.removeItem("locale");
                    window.location.href = '/login';
                }
            })
            .catch(err => {
                toastr.error("Something went wrong. Please try again", "Error");
            })
    }


    const role = localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")).data.role : ""
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col sm={12}>
                            <Card className="card-style">
                                <CardHeader>Account Setting</CardHeader>
                                <CardBody>
                                    <Tabs defaultActiveKey="1">
                                        {role !== "admin" && (
                                        <TabPane
                                            tab={
                                                <span>
                                            My Account
                                        </span>
                                            }
                                            key="1"
                                        >
                                            <AvForm
                                                className="row m-auto account-setting"
                                                onValidSubmit={(e, value) => {handleUserName(e, value)}}
                                            >
                                                <Col sm={12}>
                                                    <div className="form-group">
                                                        <AvField
                                                            type="input"
                                                            label={"User Name"}
                                                            name="name"
                                                            value={name}
                                                            validate={{ required: { value: true } }}
                                                            onChange={(e) => { setName(e.target.value) }}
                                                        >
                                                        </AvField>
                                                    </div>
                                                </Col>
                                                <Col sm={12}>
                                                    <div className="form-group">
                                                        <AvField
                                                            type="email"
                                                            label={"Email"}
                                                            name="email"
                                                            value={email}
                                                            readOnly
                                                        >
                                                        </AvField>
                                                    </div>
                                                </Col>
                                                <Col className="text-right">
                                                    <button className="btn btn-primary">
                                                        {!nameUpdating ? "Update" : (
                                                            <React.Fragment>
                                                                <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                                                Updating
                                                            </React.Fragment>
                                                        )}
                                                    </button>
                                                </Col>
                                            </AvForm>

                                        </TabPane>
                                        )}
                                        <TabPane
                                            tab={
                                                <span>
                                          Change Password
                                        </span>
                                            }
                                            key="2"
                                        >
                                            <AvForm
                                                className="row m-auto account-setting"
                                                onValidSubmit={(e, value) => {handlePassword(e, value)}}
                                            >
                                                <Col sm={12}>
                                                    <div className="form-group">
                                                        <AvField
                                                            type="password"
                                                            label={"Current Password"}
                                                            name="current_password"
                                                            validate={{ required: { value: true } }}
                                                        >
                                                        </AvField>
                                                    </div>
                                                </Col>
                                                <Col sm={12}>
                                                    <div className="form-group">
                                                        <AvField
                                                            type="password"
                                                            label={"New Password"}
                                                            name="password"
                                                        >
                                                        </AvField>
                                                    </div>
                                                </Col>
                                                <Col sm={12}>
                                                    <div className="form-group">
                                                        <AvField
                                                            type="password"
                                                            label={"Confirm Password"}
                                                            name="password_confirmation"
                                                        >
                                                        </AvField>
                                                    </div>
                                                </Col>
                                                <Col className="text-right">
                                                    <button className="btn btn-primary">
                                                        {!pwUpdating ? "Change Password" : (
                                                            <React.Fragment>
                                                                <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                                                Updating
                                                            </React.Fragment>
                                                        )}
                                                    </button>
                                                </Col>
                                            </AvForm>
                                        </TabPane>
                                    </Tabs>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { loading } = state.ScreenReducer;
    return { loading };
}

export default withRouter(connect(mapStateToProps, {})(withNamespaces()(Dashboard)));
